import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { Close2Hoc,InfoIconHoc,loaderSVG,TickHoc2 } from "../../assets/images";
import { getContactNameFromRoster, getFriendsFromRosters, getUserInfoForSearch } from "../../Helpers/Chat/User";
import { getValidSearchVal, handleFilterBlockedContact } from "../../Helpers/Utility";
import { NO_SEARCH_CHAT_CONTACT_FOUND } from "../../processENV";
import { hideModal } from "../../Redux/feature/popUpDataSlice";
import { store } from "../../Redux/store";
import SDK from "../../SDK";
import _get from "lodash-es/get";	
import Badge from "../WebChat/NewGroup/Badge";
import { getUsersListFromSDK } from "../WebChat/RecentChatSection/userLists";
import Contact from "./Contact";
import RecentSearch from "../WebChat/RecentChatSection/RecentSearch";
import { setInitialRoster } from "../../Redux/feature/rosterDataSlice";
import { formatUserIdToJid } from "../../Helpers/Chat/ChatHelper";
import { toast } from "react-toastify";

const ParticipantsPopUp = () =>{

    const globalState = useSelector(state => state);
    const { popUpData:{ modalProps: { groupMembers = [], groupName = "", groupuniqueId = "" } = { } } , appOnlineStatus : {isAppOnline} } = globalState 
    const { rosterData: { data }, blockedContact } = globalState
    const [ participantData, setParticipantData ] = React.useState({
        groupMembers: [],
        participantToAdd: [],
        errorMesage: '',
        isLoading: true,
        filteredContacts: [],
        usersList:[],
        loaderStatus: !!globalState?.rosterData?.isFetchingUserList,
    })
    const [ searchValue , setSearchValue ] = React.useState('');
    let timer = 0

    React.useEffect(()=>{
        store.dispatch(setInitialRoster())
        getUsersListFromSDK(1,"");
    },[])

    //  // React.useEffect(()=>{
    //  //   const filteredContactsList = contactsSearch(getValidSearchVal(searchValue)).filter(item=>item?.isAdminBlocked !== true && item?.isDeletedUser !== true)
    //  //   setParticipantData({
    //  //     ...participantData,
    //  //     filteredContacts: filteredContactsList,
    //  //    userList: filteredContactsList
    //  // })
    // //},[recentChatItems])

    React.useEffect(()=>{
        let selectedContactId = participantData.participantToAdd.map(ele => {
            let foundRoster = globalState.rosterData?.data?.find(el => el.userId === ele?.roster?.userId);
            if (!foundRoster.isAdminBlocked && !foundRoster.isDeletedUser) return ele;
        });

        selectedContactId = selectedContactId.filter(function( element ) {
            return element !== undefined;
        });
        setParticipantData({
            ...participantData,
            participantToAdd: selectedContactId,
            loaderStatus: globalState?.rosterData?.isFetchingUserList,
            filteredContacts: getFriendsFromRosters(handleFilterBlockedContact(data)),
            usersList:getFriendsFromRosters(handleFilterBlockedContact(data))
        });
    },[globalState.rosterData])

    const errorMessageListner = (errorMesage) => {
        setParticipantData({
            ...participantData,
            errorMesage: errorMesage
        })
    }

    const addParticipant = (userName, userInfo) => {
        setParticipantData({
            ...participantData,
            participantToAdd: participantData.participantToAdd.concat({
                userId: userName,
                ...userInfo
            })
        });
    }

    const removeParticipant = (userName) => {
        setParticipantData({
            ...participantData,
            participantToAdd:participantData.participantToAdd.filter(function (user) {
                return user.userId !== userName
            })
        });
    }

    const prepareContactToAdd = (userName, userInfo) => {
        const exists = participantData.participantToAdd.find(user => user.userId === userName)
        if (!exists) {
            return addParticipant(userName, userInfo);
        }
        return false;
    }

    const closePopup = ()=>{
        store.dispatch(hideModal())
    }

    const fetchMoreData = () => {
            let userListArrData = participantData.usersList;
            let searchWith = getValidSearchVal(searchValue);
            getUsersListFromSDK(Math.ceil((userListArrData.length / 20) + 1), searchWith);
    }

    const prepareContactToRemove = (userName) => {
        const exists = participantData.participantToAdd.find(user => user.userId === userName)
        if (exists) {
            return removeParticipant(userName)
        }
        return false;
    };

    const addUsersInGroup = () => {
        const membersCount = _get(groupMembers, "length", 0) + _get(participantData.participantToAdd, "length", 0);
        if (membersCount < 2) {
            setParticipantData({
                ...participantData,
                errorMesage: 'Select minimum of two contacts'
            });
            return
        }
        if(participantData.participantToAdd.length < 1){
           toast.error('Select minimum of one contact')
            return
        }
        if (membersCount < 239) {
            setParticipantData({
                ...participantData,
                errorMesage: ''
            })
            participantData.participantToAdd.forEach(({ userId }) => {
                const jid = formatUserIdToJid(userId);
                SDK.addParticipants(groupuniqueId, groupName, [jid]);
            })
            store.dispatch(hideModal())
        }
    }

    const contactsSearch = (searchTerm) => {
        if (!data) {
            return [];
        }
        return handleFilterBlockedContact(data).filter((item) => {
            const rosterJid = (item.username) ? item.username : item.userId;
            if (groupMembers.indexOf(rosterJid) > -1) {
                return false
            }
            const regexList = getUserInfoForSearch(item);
            return regexList.find((str) => {
                if (!item.isFriend || !str) return false
                return (str.search(new RegExp(searchTerm, "i")) !== -1)
            });
        });
    }

    const searchFilterList = (searchValueData = "") => {
        clearTimeout(timer)
        timer = setTimeout(() => {
            searchValueData = getValidSearchVal(searchValueData);
            let searchWith = searchValueData;
            if (!searchValueData) {
                setSearchValue('')
                setParticipantData({
                    ...participantData,
                    errorMesage: '',
                    filteredContacts: getFriendsFromRosters(handleFilterBlockedContact(data)),
                    userList: getFriendsFromRosters(handleFilterBlockedContact(data))
                })
                getUsersListFromSDK(1, searchWith);
                return;
            }
            const filteredContactsList = contactsSearch(searchWith)
            setSearchValue(searchValueData)
            setParticipantData({
                ...participantData,
                filteredContacts: filteredContactsList,
                userList: filteredContactsList
            })
            getUsersListFromSDK(1, searchWith);
        }, 0);
    }

    const handleUserListData = () => {
        let dataArr = [];
        let usersList = participantData.usersList;
        usersList = usersList.filter(contact => !groupMembers.includes(contact.userId));
        if (usersList.length > 0) {
            usersList.map((contact) => {
                const { username, userId } = contact
                const contactName = getContactNameFromRoster(contact);
                const updateJid = username || userId
                const isChanged = participantData.participantToAdd.findIndex(participant => participant.userId === updateJid);
                let blockedContactArr = blockedContact.data;
                const jid = formatUserIdToJid(updateJid);
                const isBlocked = blockedContactArr.indexOf(jid) > -1;
                dataArr.push(
                    <Contact
                        isBlocked={isBlocked}
                        searchValue={searchValue}
                        contactName={contactName}
                        isChanged={isChanged}
                        membersCount={groupMembers.length + participantData.participantToAdd.length}
                        errorMessageListner={errorMessageListner}
                        prepareContactToAdd={prepareContactToAdd}
                        prepareContactToRemove={prepareContactToRemove}
                        key={updateJid}
                        roster={contact}
                        {...contact}
                    />
                )
            });
        }
        return dataArr;
    }

    let { filteredContacts } = participantData
    filteredContacts = filteredContacts.filter(contact => !groupMembers.includes(contact.userId));
    const userListArr = handleUserListData();

    return (
    <React.Fragment>
        <div className="popup-wrapper">
            <div className="popup-container add-participant audio">
                <div className="popup-container-inner">
                    <div className="popup-container-header">
                    <i onClick={closePopup} className="closePopup"><Close2Hoc viewBox="0 0 15.4 15.468"/></i>
                    <h5>Add group participants</h5>
                    <i
                        className="addPopup"
                        onClick={addUsersInGroup}
                        data-jest-id={"jestaddUsersInGroup"}
                    >
                        <TickHoc2 viewBox="0 0 22.086 16.244" />
                    </i>
                    </div>
                    <RecentSearch search={searchFilterList} />
                    <div className="popup-body" style={{overflow:"hidden"}}>
                        <div className="contactList">
                        {participantData.loaderStatus && isAppOnline && <div className="response_loader style-2">
                            <img src={loaderSVG} alt="loader"  />
                        </div>
                        }
                        {filteredContacts.length === 0 && searchValue && !participantData.loaderStatus &&
                        <span className="searchErrorMsg"><InfoIconHoc viewBox="0 0 14 14"/>
                        {NO_SEARCH_CHAT_CONTACT_FOUND}
                        </span>} 
                            {userListArr.length > 0 &&
                            <ul style={{height:"100%"}} className="chat-list-ul" id="scrollableUl-addparticipant">
                            <li className="chat-list-li BadgeContainer">
                            <div className="selectedBadge">
                                <ul>
                                    {participantData.participantToAdd.map(participant => {
                                        const { userId } = participant
                                        return <Badge
                                            key={userId}
                                            {...participant}
                                            removeParticipant={removeParticipant}
                                        />
                                    })}
                                </ul>
                            </div>
                            </li>
                            {isAppOnline ?
                            <InfiniteScroll
                            dataLength={userListArr.length}
                            next={fetchMoreData}
                            hasMore={true}
                            scrollableTarget="scrollableUl-addparticipant"
                            >
                            {handleUserListData()}
                            </InfiniteScroll>
                        : handleUserListData()
                        }
                        </ul>
                            } 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </React.Fragment>
    )
}

export default ParticipantsPopUp;